import React from "react";
import ContableModule from "../Contable";

export default function Egresos() {
  return <ContableModule view="expense" />;
}
